import React from 'react'
import classnames from 'classnames'
import { useSelector } from 'react-redux'

import { isNewStylesThemeEnabledSelector } from '../../../modules/selectors/app'

import useStyles from './style'
import * as classes from './style.css'

function Radio({
  id,
  name = '',
  value = '',
  className = '',
  titleClassName = '',
  label = '',
  subText = '',
  onChange = () => {},
  checked = false,
  disabled = false,
  smallFontSize = false,
  ...restProps
}: RadioProps) {
  const isNewStylesThemeEnabled = useSelector(isNewStylesThemeEnabledSelector)
  // @ts-ignore
  const legacyClasses = useStyles({ checked, disabled, smallFontSize })

  const vanillaClasses = {
    ...classes,
    radioTitle: classnames(classes.radioTitle({ smallFontSize, disabled }), checked && classes.radioTitleChecked)
  }
  const activeClasses = (isNewStylesThemeEnabled ? vanillaClasses : legacyClasses) as any

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.persist()
    onChange(event)
  }

  return (
    <span className={classnames(activeClasses.radio, className)}>
      <input
        type="radio"
        id={id}
        name={name}
        value={value}
        onChange={handleOnChange}
        checked={checked}
        disabled={disabled}
        className={activeClasses.radioInput}
        {...restProps}
      />
      <label htmlFor={id} className={activeClasses.radioLabel}>
        {label && <div className={classnames(activeClasses.radioTitle, titleClassName)}>{label}</div>}
        {subText && <div className={activeClasses.radioSubText}>{subText}</div>}
      </label>
    </span>
  )
}

interface RadioProps {
  id: string
  name?: string
  value?: string
  className?: string
  titleClassName?: string
  label?: string | React.ReactNode
  subText?: string | React.ReactNode
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  checked?: boolean
  disabled?: boolean
  smallFontSize?: boolean
  [key: string]: any
}

export default Radio
